// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Aq1Op","index":"styles_index__2hGO7"};